import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'

export default function Support() {
const navigate = useNavigate()
return (
<div>
<Header />
<div className="container" style={{ maxWidth: 800, padding: '2rem 1rem' }}>
<button className="btn btn-ghost btn-sm" onClick={() => navigate(-1)} style={{ marginBottom: 24 }}>← Back</button>
<h1 style={{ fontSize: 28, fontWeight: 600, marginBottom: 8, color: 'var(--navy)' }}>Support</h1>
<p style={{ color: 'var(--text-muted)', marginBottom: 32 }}>We're here to help! Contact us or browse our FAQs below.</p>

<div className="card card-body" style={{ marginBottom: 16 }}>
<h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 12, color: 'var(--navy)' }}>Contact Us</h2>
<p style={{ color: 'var(--text-muted)', marginBottom: 8 }}>For support, questions or feedback:</p>
<p><strong>Email:</strong> <a href="mailto:hello@hireitnow.au" style={{ color: 'var(--primary)' }}>hello@hireitnow.au</a></p>
<p><strong>Website:</strong> <a href="https://hireitnow.au" style={{ color: 'var(--primary)' }}>hireitnow.au</a></p>
<p style={{ color: 'var(--text-muted)', marginTop: 8, fontSize: 13 }}>We aim to respond within 24 hours.</p>
</div>

<div className="card card-body" style={{ marginBottom: 16 }}>
<h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 16, color: 'var(--navy)' }}>Frequently Asked Questions</h2>

<div style={{ marginBottom: 16 }}>
<div style={{ fontWeight: 500, marginBottom: 4 }}>How do I list an item?</div>
<p style={{ fontSize: 14, color: 'var(--text-muted)' }}>Tap the + List an item button, fill in your item details, add photos and set your price per hour.</p>
</div>

<div style={{ marginBottom: 16 }}>
<div style={{ fontWeight: 500, marginBottom: 4 }}>How do I hire an item?</div>
<p style={{ fontSize: 14, color: 'var(--text-muted)' }}>Browse listings, tap on an item, select your dates and tap Request to book. The owner will confirm your booking.</p>
</div>

<div style={{ marginBottom: 16 }}>
<div style={{ fontWeight: 500, marginBottom: 4 }}>How do payments work?</div>
<p style={{ fontSize: 14, color: 'var(--text-muted)' }}>Payments are processed securely via Stripe. You won't be charged until the owner confirms your booking.</p>
</div>

<div style={{ marginBottom: 16 }}>
<div style={{ fontWeight: 500, marginBottom: 4 }}>What if something goes wrong?</div>
<p style={{ fontSize: 14, color: 'var(--text-muted)' }}>You can report a problem on any confirmed booking. Our team will review and assist within 24 hours.</p>
</div>

<div style={{ marginBottom: 16 }}>
<div style={{ fontWeight: 500, marginBottom: 4 }}>How do I delete my account?</div>
<p style={{ fontSize: 14, color: 'var(--text-muted)' }}>Go to Profile and scroll down to Danger Zone. Tap Delete my account and confirm.</p>
</div>

<div style={{ marginBottom: 16 }}>
<div style={{ fontWeight: 500, marginBottom: 4 }}>Is HireIt free to use?</div>
<p style={{ fontSize: 14, color: 'var(--text-muted)' }}>HireIt is free to download and list items. We charge a 12% service fee on completed hires.</p>
</div>
</div>

<div className="card card-body">
<h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 12, color: 'var(--navy)' }}>Legal</h2>
<div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
<a href="/terms" style={{ color: 'var(--primary)' }}>Terms & Conditions</a>
<a href="/privacy" style={{ color: 'var(--primary)' }}>Privacy Policy</a>
</div>
</div>
</div>
</div>
)
}